import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import './index.scss'
import {PaymentGatewayOptions} from '../../../models/paymentGateway';
import __i18n from "../../../intl/__i18n";

function NewUsersChart({data, intl}) {
  const totalValues = data.map(item => item.total);
  const maxValue = Math.max(totalValues)
  const sumValue = totalValues.reduce((a, b) => a + b, 0);
  const chartData = PaymentGatewayOptions.map( item => {
    const selectedValue = data.find( opt => opt.payment_gateway === item.value);
    const y = selectedValue ? selectedValue.total : 0;
    return({
      name : item.label,
      y : y * 100 / sumValue,
      sliced: y === maxValue,
      selected: y === maxValue
    })
  });
  
  return (
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: __i18n("Total payment form each gateway")
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
              },
              showInLegend: true
            }
          },
          series: [{
            colorByPoint: true,
            data: chartData
          }]
        }}
      />
    </div>
  )
}

export default NewUsersChart

